import articles from './../news-articles.js'

// states
const state = {
  articles
}

//getters
const getters = {
  articles: state => state.articles
}

// ------ export module -------
const news = {
  namespaced: true,
  state,
  getters
}

export default news;



// WEBPACK FOOTER //
// ./src/store/modules/news.js